import { connect } from 'react-redux';
import PreviewPdfModal from '../components/PreviewPdfModal';

const mapStateToProps = (state, ownProps) => {
  const { isOpen, hideModal, url, downloadUrl, header, canPrintPdf = true, editUrl = null } = ownProps;
  return {
    isOpen,
    hideModal,
    url,
    downloadUrl,
    header,
    canPrintPdf,
    editUrl
  };
};

export default connect(mapStateToProps)(PreviewPdfModal);
